import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorMessageDirective } from './directives/error-message.directive';
import { TruncatePipe } from './pipes/truncate.pipe';
import { DateFormatPipe } from './pipes/date.pipe';
import { CapitalizePipe } from './pipes/capitalize.pipe';
import { TruncateDecimalPipe } from './pipes/truncate-decimal.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [
    ErrorMessageDirective,
    TruncatePipe,
    DateFormatPipe,
    CapitalizePipe,
    TruncateDecimalPipe,
  ],
  exports: [
    CommonModule,
    ErrorMessageDirective,
    TruncatePipe,
    DateFormatPipe,
    CapitalizePipe,
    TruncateDecimalPipe,
  ],
})
export class SharedModule {}
